import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["viewport", "previousButton", "nextButton"]

  connect() {
    this.updateButtons = this.updateButtons.bind(this)
    this.viewportTarget.addEventListener("scroll", this.updateButtons, { passive: true })
    window.addEventListener("resize", this.updateButtons)
    this.updateButtons()
  }

  disconnect() {
    this.viewportTarget.removeEventListener("scroll", this.updateButtons)
    window.removeEventListener("resize", this.updateButtons)
  }

  previous() {
    this.scrollBy(-1)
  }

  next() {
    this.scrollBy(1)
  }

  scrollBy(direction) {
    const distance = Math.max(this.viewportTarget.clientWidth * 0.8, 240)

    this.viewportTarget.scrollBy({
      left: direction * distance,
      behavior: "smooth"
    })
  }

  updateButtons() {
    const maxScrollLeft = this.viewportTarget.scrollWidth - this.viewportTarget.clientWidth
    const hasOverflow = maxScrollLeft > 1
    const atStart = this.viewportTarget.scrollLeft <= 1
    const atEnd = this.viewportTarget.scrollLeft >= maxScrollLeft - 1

    this.previousButtonTarget.disabled = !hasOverflow || atStart
    this.nextButtonTarget.disabled = !hasOverflow || atEnd
  }
}
